import { Component, Input, EventEmitter, Output  } from '@angular/core';

import { GenericValue  } from 'hisng';

import { SEARCH_CONFIG_EMPLOYMENT } from 'app/fs/res/common/model/searchConstants';
import { Person } from 'app/fs/res/common/model/person/person';

import { Employment } from 'app/fs/res/employment/model/employment';
import { Employee, EmploymentOrganization } from 'app/fs/res/employment/model/employment-classes';
import { ResearchInfrastructureEmployment } from 'app/fs/res/research-infrastructure/model/research-infrastructure-classes';
import { ResearchPartnerSimple } from 'app/fs/res/common/model/researchPartner/researchPartner';

@Component( {
    selector: 'res-research-infrastructure-search-person-employment',
    templateUrl: './research-infrastructure-search-person-employment.component.html',
} )
export class ResearchInfrastructureSearchPersonEmploymentComponent {
    @Input() researchInfrastructureEmployment: ResearchInfrastructureEmployment;
    @Output() submitResearchInfrastructureEmployment: EventEmitter<void> = new EventEmitter();

    readonly SEARCH_CONFIG_EMPLOYMENT = SEARCH_CONFIG_EMPLOYMENT;

    public onSubmitSelection( event: any[] ) {
        this.setResearchInfrastructureEmployee( event[0] );
        //console.log('ResearchInfrastructureSearchPersonEmploymentComponent: ', this.researchInfrastructureEmployment);
        this.submitResearchInfrastructureEmployment.emit();
    }

    private setResearchInfrastructureEmployee( searchResultOption: any ) {
        let isInternal = searchResultOption[
            'IF_THEN_ELSE(Employment.orgunits.orgunitObj.currentVersions.defaulttext,null,\'true\',\'false\')'];
        let employment = new Employment();
        employment.id = searchResultOption['Employment.id'];

        let employee = new Employee();
        employee.person = new Person();
        employee.person.surname = searchResultOption['Employment.employee.person.surname'];
        employee.person.firstname = searchResultOption['Employment.employee.person.firstname'];
        employment.employee = employee;

        let employmentOrganization = new EmploymentOrganization();
        if ( isInternal ) {
            let gvOrgunit = new GenericValue();
            gvOrgunit.text = searchResultOption['COALESCE(Employment.orgunits.orgunitObj.currentVersions.defaulttext,'
                + 'Employment.orgunits.researchPartner.business.defaulttext)'];
            employmentOrganization.organization = gvOrgunit;
        } else {
            employmentOrganization.researchPartner = new ResearchPartnerSimple(
                null, searchResultOption['COALESCE(Employment.orgunits.orgunitObj.currentVersions.defaulttext,'
                + 'Employment.orgunits.researchPartner.business.defaulttext)'],
                [], null, null );
        }
        employment.orgunits = [];
        employment.orgunits.push( employmentOrganization );

        this.researchInfrastructureEmployment.employment = employment;
    }

}
